<div class="container">
	<div class="content">
		<div class="ui-lg-12 ui-md-12 ui-g-12 text-center p-0">
			<img alt="SmartyCubes Logo" class="logo" src="./assets/img/smartyCubes-logo.png" />
			<label>
				{{ 'registration.expired-message' | translate }}
			</label>
		</div>
		<div class="form-container">
			<form (submit)="onSubmit()" [formGroup]="form" novalidate>
				<p-card class="nice-border" styleClass="ui-card-shadow">
					<div class="ui-g">
						<div class="ui-lg-12 ui-md-12 ui-g-12">
							<label>
								<b>{{ 'registration.email' | translate }}</b>
							</label>
							<input class="w-100" formControlName="email" name="email" pInputText type="text" />
							<span class="information">
								<i class="fas fa-question-circle"></i>
								{{ 'registration.email-reactivation' | translate }}
							</span>
							<sis-validation-summary
								[form]="form"
								[visible]="invalidForm"
								name="email"
								class="mt5"></sis-validation-summary>
						</div>

						<ng-template #footer>
							<div class="ui-lg-12 login-border">
								<button
									pButton
									type="submit"
									class="g-recaptcha tt-btn-link tt-btn btn-md hover_translate ui-dark-button w-100 ui-button"
									[label]="'registration.activation-send' | translate"
									data-action="submit"
									data-callback="onSubmit"
									data-sitekey="6LdhNOwpAAAAALa1Jaqz9cqrtu1wNYgSy6mDoANi"
									[disabled]="form.invalid"></button>
							</div>
						</ng-template>
					</div>
				</p-card>
			</form>
		</div>
	</div>
</div>
